import { Box } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

const VSign = () => (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2432 1.14941L4.5765 8.14941L1.24316 4.64941"
      stroke="#1D1F20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ColorSwatch = ({
  color,
  selected,
  onClick,
  size = 'medium',
}: {
  color: string;
  selected?: boolean;
  onClick?: () => void;
  size?: 'small' | 'medium';
}) => {
  const borderColor = selected ? colors.grey[900] : colors.grey[300];
  return (
    <Box
      sx={{
        width: size === 'small' ? '16px' : '24px',
        height: size === 'small' ? '16px' : '24px',
        backgroundColor: color,
        borderRadius: '50%',
        border: `1px solid ${borderColor}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      {selected && <VSign />}
    </Box>
  );
};
